module.exports = __webpack_public_path__ + "media/images/flags/LV-ab458481805bf7f250814e82c96117d0.svg";